import PropTypes from 'prop-types';
import { unitToString } from '@/utils/unitUtils';
import { CAPACITY_MODE } from './capacityMode';

const CapacityInfo = ({ capacityMode, value, capacityFactor, conversionStr }) => {
  const conversion = conversionStr ? JSON.parse(conversionStr) : null;
  const unitLabel = unitToString(conversion?.unit);

  const alternateValue =
    capacityMode === CAPACITY_MODE.POWER_OUTPUT ? value / (capacityFactor / 100) : value * (capacityFactor / 100);

  const alternateLabel = capacityMode === CAPACITY_MODE.POWER_OUTPUT ? 'Plant capacity' : 'Avg. Power Output';

  return (
    <div className="mt-2 text-sm italic text-base-content/60">
      {!isNaN(alternateValue) && (
        <div>
          {alternateLabel} = {parseFloat(alternateValue.toFixed(3))} {unitLabel}
        </div>
      )}
      <div>Capacity Factor (Parameter): {capacityFactor}%</div>
    </div>
  );
};

CapacityInfo.propTypes = {
  capacityMode: PropTypes.string.isRequired,
  value: PropTypes.number,
  capacityFactor: PropTypes.number.isRequired,
  conversionStr: PropTypes.string,
};

export default CapacityInfo;
